<template>
    <title-content
        v-if="content.type.split('_')[0] === 'title'"
        :content="content"
    />
    <regular-content
        v-else
        :content="content"
        :actions="actions"
    />
</template>

<script>
import RegularContent from './RegularContent.vue';
import TitleContent from "./TitleContent.vue";

export default {
    components: {
        RegularContent,
        TitleContent
    },
    props: ["content", "actions"]
}
</script>